var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text_container" }, [
    _c("div", { staticClass: "page_txt" }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.sequenceText) } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }